import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DailyLogPageModule } from '../../../daily-log/daily-log/daily-log.module';
import { SharedModule } from '../../../shared/shared.module';
import { GridModule, RowFilterModule } from '@progress/kendo-angular-grid';
import { DirectivesModule } from '../../../../directives/directives.module';
import {JackingActivityV2EditPage} from './jacking-activity-edit-v2';
import {JackingFieldComponent} from '../components/jacking-field-component/jacking-field.component';
import {IonicSelectableModule} from 'ionic-selectable';
import {PipesModule} from '../../../../pipes/pipes.module';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {JackingFieldIntegerComponent} from '../components/jacking-field-component/sub-components/jacking-field-integer/jacking-field-integer.component';
import {JackingFieldDateTimeComponent} from '../components/jacking-field-component/sub-components/jacking-field-date-time/jacking-field-date-time.component';
import {TextMaskModule} from 'angular2-text-mask';
import {JackingLoadCellsGridComponent} from '../components/jacking-load-cells-grid/jacking-load-cells-grid.component';
import {JackingEventsTableComponent} from '../components/jacking-events/jacking-events-table/jacking-events-table.component';
import {JackingLegSummariesComponent} from '../components/jacking-leg-summaries/jacking-leg-summaries.component';
import {JackingSignaturesComponent} from '../components/jacking-signatures/jacking-signatures.component';
import {JackingFinalValuesComponent} from '../components/jacking-events/jacking-final-values/jacking-final-values.component';
import {JackingFinalValuesGridComponent} from '../components/jacking-events/jacking-final-values/jacking-final-values-grid/jacking-final-values-grid.component';
import {JackingFinalPositionGridComponent} from '../components/jacking-events/jacking-final-values/jacking-final-position-grid/jacking-final-position-grid.component';
import {FieldPositioningGridComponent} from '../components/field-positioning-grid/field-positioning-grid.component';
import {JackingCancelModalComponent} from '../components/jacking-cancel-modal/jacking-cancel-modal.component';
import {JackingValidationSummaryComponent} from '../components/jacking-validation-summary/jacking-validation-summary.component';
import {JackingAlertContainerComponent} from '../components/jacking-alert-container/jacking-alert-container.component';
import {JackingDateTimeCellComponent} from '../components/jacking-date-time-cell/jacking-date-time-cell.component';
import {
  JackingExternalChangeNotificationComponent
} from '../components/jacking-external-change-notification/jacking-external-change-notification.component';

@NgModule({
  declarations: [
    JackingActivityV2EditPage,
    JackingFieldComponent,
    JackingFieldIntegerComponent,
    JackingFieldDateTimeComponent,
    JackingLoadCellsGridComponent,
    JackingEventsTableComponent,
    JackingLegSummariesComponent,
    JackingSignaturesComponent,
    JackingFinalValuesComponent,
    JackingFinalValuesGridComponent,
    JackingFinalPositionGridComponent,
    FieldPositioningGridComponent,
    JackingValidationSummaryComponent,
    JackingAlertContainerComponent,
    JackingDateTimeCellComponent,
    JackingExternalChangeNotificationComponent
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(JackingActivityV2EditPage),
    DailyLogPageModule,
    SharedModule,
    GridModule,
    RowFilterModule,
    IonicSelectableModule,
    PipesModule,
    FontAwesomeModule,
    TextMaskModule
  ],
  exports: [
    FieldPositioningGridComponent

  ]
})
export class JackingActivityEditV2PageModule {
}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v2/jacking-activity-edit-v2/jacking-activity-edit-v2.module.ts